import ScrollTrigger from '@terwanerik/scrolltrigger';
import reframe from 'reframe.js';
import Plyr from 'plyr';
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay]);

(function ($) {
	// Menu Trigger
	$('.menu-trigger').on('click', function (e) {
		e.preventDefault();
		$('body').toggleClass('show-menu');
	});

	// Play BGM Button
	$('.js-play-bgm-button').on('click', function (e) {
		e.preventDefault();
		const bgm = document.querySelector('#bgm');
		bgm.play();
	});

	reframe('iframe');

	// Audio Player
	const players = Plyr.setup('.js-player', {
		controls: ['play', 'progress']
	});

	// Voice Sample Slider
	const sampleVoiceSwiper = new Swiper(
		'.sample-voice-list > .swiper-container',
		{
			slidesPerView: 1,
			centeredSlides: true,
			// loop: true,
			breakpoints: {
				740: {
					slidesPerView: 3
				}
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			},
			on: {
				slideChange: function () {
					players.forEach((player) => player.stop());
				}
			}
		}
	);

	// Moderator Slider
	const moderatorSwiper = new Swiper(
		'.moderator-page__img .swiper-container',
		{
			init: false,
			slidesPerView: 1,
			loop: true,
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true
			}
		}
	);

	moderatorSwiper.init();

	// ScrollTrigger
	const trigger = new ScrollTrigger({
		trigger: {
			once: true
		}
	});
	trigger.add('[data-trigger]');
})(jQuery);
